import { generateOperationKey } from "@orpc/tanstack-query";
import { AccountWorkspace, accountPages } from "@/components/account/account-workspace";
import {
  AccountOrganizationsSettings,
  AccountProfileSettings,
  AccountSecuritySettings,
} from "@/components/account/account-settings";
import { useInvalidateOrganization } from "@/hooks/use-invalidate-organization";
import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account/$accountView")({
  component: AccountPage,
  beforeLoad: ({ params }) => {
    if (!accountPages.some((page) => page.params.accountView === params.accountView))
      throw notFound();
  },
  head: () => ({ meta: [{ title: "Papier - Account" }] }),
});

function AccountPage() {
  const { accountView } = Route.useParams();
  const { queryClient } = Route.useRouteContext();
  const invalidateOrganization = useInvalidateOrganization();
  return (
    <AccountWorkspace view={accountView}>
      {accountView === "settings" && <AccountProfileSettings />}
      {accountView === "security" && <AccountSecuritySettings />}
      {accountView === "organizations" && (
        <AccountOrganizationsSettings
          onInvalidateInvitations={async () => {
            await Promise.all([
              queryClient.invalidateQueries({
                queryKey: generateOperationKey(["authTrpc", "getUserInvitations"]),
              }),
              queryClient.invalidateQueries({
                queryKey: generateOperationKey(["authTrpc", "getUserOrganizations"]),
              }),
            ]);
          }}
          onLeaveOrganizationSuccess={invalidateOrganization}
        />
      )}
    </AccountWorkspace>
  );
}
